import { render } from "./Loader.vue?vue&type=template&id=0dc46c36"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=0dc46c36&module=true&lang=scss"
cssModules["$style"] = style0

import exportComponent from "C:\\OpenServer\\domains\\front-studixy.dm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__